import { createContext, useContext, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldWarning } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { VERIFICATION_ROUTE, verificationCopy } from "@/lib/verification";

const Ctx = createContext({ openGate: () => {} });
export const useVerificationGate = () => useContext(Ctx);

// Globaler, wiederverwendbarer Handler für 403 FULL_VERIFICATION_REQUIRED.
// EIN Modal für die ganze App – kein Screen implementiert eigene Verification-Texte.
export function VerificationGateProvider({ children }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [missing, setMissing] = useState({ age: true, identity: true });

  const openGate = useCallback((m) => {
    setMissing(m && (m.age || m.identity) ? m : { age: true, identity: true });
    setOpen(true);
  }, []);

  const copy = verificationCopy(missing);

  return (
    <Ctx.Provider value={{ openGate }}>
      {children}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="verification-gate-modal">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ShieldWarning size={20} weight="fill" className="text-secondary" />{copy.title}
            </DialogTitle>
            <DialogDescription data-testid="verification-gate-text">{copy.text}</DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="verification-gate-cancel" className="rounded-full">Später</Button>
            <Button
              data-testid="verification-gate-cta"
              onClick={() => { setOpen(false); navigate(VERIFICATION_ROUTE); }}
              className="rounded-full"
            >
              {copy.button}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Ctx.Provider>
  );
}
